// todo: better checks in render() methods (e.g. no render at pre-login state - no room etc.)

import React from 'react'
import { connect } from 'react-redux'

import Popup from '../Popup/index';

import Registry from '../../../registry/index';
import {ROOM_TYPE_PERSONAL} from '../../../constants/rooms';

class RoomClosedPopup extends Popup {
    constructor(props) {
        super(props);

        this.userClosable = false;
        this.showOverlay = true;
        this.afterClosePositionReset = false;
    }

    componentWillUpdate(nextProps, nextState) {
        if (
            (this.props.currentRoom.exists && !nextProps.currentRoom.exists) ||
            (this.props.currentRoom.type != nextProps.currentRoom.type && !nextProps.currentRoom.exists)
        ) {
            this.open();
        }
    }

    render() {
        let lang = Registry.get('locale');

        let {currentRoom} = this.props;

        let mainRoomUrl = Registry.get('chatInterface').getPrimaryRoomURL();

        let message;
        if (currentRoom.type == ROOM_TYPE_PERSONAL) {
            message = <p dangerouslySetInnerHTML={{__html:lang.personal_room_closed_message()}}/>;
        } else {
            message = <p dangerouslySetInnerHTML={{__html:lang.room_closed_message(currentRoom.id)}}/>
        }

        return (
            <div className={'popup popup-room-closed ' + this.state.visibility} ref={(ref) => this._ref = ref}>
                {message}
                <a className="popup-button enter" href={mainRoomUrl}>{lang.enter_main_room}</a>
            </div>
        )
    }

}

RoomClosedPopup.generateKey = function(props) { return 'room-closed-popup' };
RoomClosedPopup.mount = function(props, onMount) { return Popup.mount(RoomClosedPopup, props, onMount) };
RoomClosedPopup.open = function(props) {
    var id = RoomClosedPopup.generateKey(props);

    if (!Popup.popups[id]) {
        RoomClosedPopup.mount(props, () => Popup.popups[id].open());
    } else {
        Popup.popups[id].open()
    }
};

function mapStateToProps(state, ownProps) {
    return {
        currentRoom: state.currentRoom
    }
}

var RoomClosedPopup_connect = connect(mapStateToProps, null, null, {forwardRef: true})(RoomClosedPopup);

RoomClosedPopup_connect.generateKey = function() { return 'room-closed-popup' };
RoomClosedPopup_connect.mount = function(props) { return Popup.mount(RoomClosedPopup_connect, props) };

export default RoomClosedPopup_connect;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/RoomClosedPopup/index.js